export enum PickingListReTransportType {
    Employee = 1,
    Partner = 2
}
